<template>
  <div>
    <div v-if="!universitiesExist">
      <div class="relative">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-300" />
        </div>
        <div class="relative flex justify-start">
          <span class="pr-3 bg-light-grey text-lg font-medium text-vice-teal-700">University</span>
        </div>
      </div>
      <div class="mt-8 text-gray-500 text-center">University with students will appear here.</div>
    </div>

    <div v-for="uni in this.universities" :key="uni.id" class="pb-11">
      <div class="relative">
        <div class="absolute inset-0 flex items-center" aria-hidden="true">
          <div class="w-full border-t border-gray-300" />
        </div>
        <div class="relative flex justify-between items-center">
          <span class="pr-3 bg-light-grey text-lg font-medium text-vice-teal-700">
            Accounts at {{ uni.name }}
          </span>
          <div class="bg-light-grey pl-3">
            <select
              @change="filterByRole($event.target.value, uni.id)"
              class="
                mt-1
                block
                w-full
                pl-3
                pr-10
                py-2
                text-base
                border-gray-300
                focus:outline-none
                focus:ring-indigo-500
                focus:border-indigo-500
                sm:text-sm
                rounded-md
              "
            >
              <!-- :class="{ 'opacity-50 pointer-events-none': !Object.keys(uni.users).length }"-->

              <option
                v-for="role in roles"
                :value="role"
                :key="uni.id + role"
                :selected="roles[0] === role"
              >
                {{ role }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="flex flex-col mt-8">
        <div v-if="!Object.keys(uni.users).length" class="text-gray-500 text-center">
          Students at {{ uni.name }} will appear here.
        </div>
        <div v-else class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow-sm overflow-hidden border border-gray-200 sm:rounded-lg">
              <table class="table-fixed min-w-full divide-y divide-gray-50">
                <thead>
                  <tr class="border-b border-gray-200">
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xxs font-medium text-gray-500 tracking-wider"
                    >
                      NAME
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xxs font-medium text-gray-500 tracking-wider"
                    >
                      EMAIL
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-left text-xxs font-medium text-gray-500 tracking-wider"
                    >
                      UNIVERSITY
                    </th>
                    <th
                      scope="col"
                      class="
                        px-6
                        py-3
                        text-center text-xxs
                        font-medium
                        text-gray-500
                        tracking-wider
                      "
                    >
                      GROUP
                    </th>
                    <th
                      scope="col"
                      class="px-6 py-3 text-xxs font-medium text-gray-500 tracking-wider"
                    >
                      PRO-COURSE
                    </th>
                    <th
                      scope="col"
                      class="
                        px-6
                        py-3
                        text-center text-xxs
                        font-medium
                        text-gray-500
                        tracking-wider
                      "
                    >
                      ID
                    </th>
                    <th
                      scope="col"
                      class="
                        px-6
                        py-3
                        text-center text-xxs
                        font-medium
                        text-gray-500
                        tracking-wider
                      "
                    >
                      AVATAR
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(user, userIdx) in uni.users"
                    :key="user.id"
                    :class="userIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                  >
                    <td class="px-6 py-4 text-xs font-medium text-vice-teal-900">
                      <span class="cursor-pointer">
                        {{ user.name }}
                      </span>
                    </td>
                    <td class="px-6 py-4 text-left whitespace-nowrap text-xs text-gray-500">
                      {{ user.email }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500">
                      {{ uni.name }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap text-xs text-gray-500 text-center">
                      {{ user.group_name ?? '-' }}
                    </td>
                    <td class="px-6 py-4 text-center">
                      <SquaredSuccessIcon
                        v-if="user.pro_course"
                        class="inline-block"
                      ></SquaredSuccessIcon>
                      <SquaredFailIcon v-else class="inline-block"></SquaredFailIcon>
                    </td>
                    <td class="px-6 py-4 text-center whitespace-nowrap text-xs text-gray-500">
                      {{ user.id }}
                    </td>
                    <td class="px-6 py-4 text-center whitespace-nowrap text-xs text-gray-500">
                      <ViceAvatar
                        :image="user.profile_photo_url"
                        :name="user.name"
                        class="w-8 h-8 inline-block"
                      />
                    </td>
                    <td class="px-6 py-4 text-center whitespace-nowrap text-xs text-gray-500">
                      <div v-if="user.role === 'student'">
                        <div
                          v-if="user.request_id"
                          class="flex sm:items-center gap-3"
                          :key="user.request_id"
                        >
                          <ViceButton
                            type="button"
                            @click="denyJoinRequest(user.request_id, user.id)"
                            :disabled="this.denyPending"
                            medium
                            rose
                          >
                            DENY
                          </ViceButton>
                          <ViceButton
                            type="button"
                            @click="acceptJoinRequest(user)"
                            :disabled="this.acceptPending"
                            medium
                            dark
                          >
                            ACCEPT
                          </ViceButton>
                        </div>
                        <div v-else class="inline-flex sm:items-center gap-6" :key="user.id">
                          <PencilEdit
                            class="cursor-pointer"
                            @click="toggleEditUserModal(true, user)"
                          />
                          <TrashRemove
                            class="cursor-pointer"
                            @click="removeUserFromUniversity(user.id, user.university_id)"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <EditUserModal
    @toggleEditUserModal="toggleEditUserModal"
    v-if="isEditUser"
    :user="editableUser"
  />
</template>

<script>
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';
import ViceAvatar from '@/Components/Avatars/ViceAvatar.vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';
import SquaredSuccessIcon from '@/Components/Icons/SquaredSuccessIcon.vue';
import SquaredFailIcon from '@/Components/Icons/SquaredFailIcon.vue';
import PencilEdit from '@/Components/Icons/PencilEdit.vue';
import TrashRemove from '@/Components/Icons/TrashRemove.vue';
import EditUserModal from '@/Components/Modals/EditUserModal.vue';

export default {
  name: 'Students',
  components: {
    EditUserModal,
    TrashRemove,
    PencilEdit,
    ViceButton,
    SquaredFailIcon,
    SquaredSuccessIcon,
    ViceAvatar,
  },
  computed: {
    Inertia() {
      return Inertia;
    },
    universitiesExist() {
      return Object.keys(this.$page.props.universities).length;
    },
  },
  data() {
    return {
      universities: [],
      initialUnis: [],
      isEditUser: false,
      editableUser: null,
      denyPending: false,
      acceptPending: false,
      roles: { student: 'Students', clinician: 'Clinicians', admin: 'Admins' },
    };
  },

  mounted() {
    this.setUniversities();
    this.filterByRole();
  },

  methods: {
    setUniversities() {
      this.universities = this.$page.props.universities
        .map((university) => {
          const joinRequests = university.join_university_requests.concat(university.users);
          const joinClinicians = joinRequests.concat(university.clinicians);
          const uniqueUsers = joinClinicians.filter(
            (user, index, self) => index === self.findIndex((u) => u.id === user.id),
          );
          return {
            id: university.id,
            name: university.name,
            users: uniqueUsers,
            userCount: uniqueUsers.length,
          };
        })
        .sort((a, b) => b.userCount - a.userCount);
      this.initialUnis = this.universities;
    },

    filterByRole(roleName = null, uniId = null) {
      if (uniId === null) {
        this.universities = this.universities.map((uni) => {
          const filteredUsers = uni.users.filter((user) => user.role === 'student');
          return {
            ...uni,
            users: filteredUsers,
            userCount: filteredUsers.length,
          };
        });
      } else {
        const role = Object.keys(this.roles).find((key) => this.roles[key] === roleName);
        const originalUni = this.initialUnis.find((uni) => uni.id === uniId);
        this.universities = this.universities.map((uni) => {
          if (uniId === uni.id) {
            const filteredUsers = originalUni.users.filter((user) => user.role === role);
            return {
              ...uni,
              users: filteredUsers,
              userCount: filteredUsers.length,
            };
          }
          return { ...uni };
        });
      }
    },

    async acceptJoinRequest(user) {
      this.acceptPending = true;
      try {
        const accepted = await axios.post(route('user.join.university.accept', user.request_id));
        if (accepted.data) {
          this.markAsJoined(user.id);
          this.$page.props.message = 'User join request was ACCEPTED';
        }
      } catch (error) {
        console.error(error);
      }
      this.acceptPending = false;
    },

    async denyJoinRequest(requestId, userId) {
      this.denyPending = true;
      try {
        const deny = await axios.post(route('user.join.university.deny', requestId));
        if (deny.data) {
          this.removeUserFromList(userId);
          this.$page.props.message = 'User join request was DENIED';
        }
      } catch (error) {
        console.error(error);
      }
      this.denyPending = false;
    },

    markAsJoined(userId) {
      this.universities.forEach((university) => {
        const user = university.users.find((item) => item.id === userId);
        if (user) {
          delete user.request_id;
        }
      });
    },

    removeUserFromList(userId) {
      this.universities.forEach((university) => {
        university.users = university.users.filter((user) => user.id !== userId);
      });
      this.initialUnis.forEach((university) => {
        university.users = university.users.filter((user) => user.id !== userId);
      });
    },

    updateUserInList(user) {
      const student = this.universities
        .flatMap((university) => university.users)
        .find((item) => item.id === user.id);

      if (student) {
        Object.assign(student, user);
      }
    },

    async toggleEditUserModal(show = false, user = null) {
      this.isEditUser = show;

      if (show && user) {
        this.editableUser = user;
      } else if (!show && user) {
        this.updateUserInList(user);
        this.$page.props.message = `Student ${user.name} has been updated`;
      } else {
        this.editableUser = null;
      }
    },

    async removeUserFromUniversity(userId, universityId) {
      try {
        const remove = await axios.post(route('university.remove.user', universityId), { userId });
        if (remove.data) {
          this.removeUserFromList(userId);
          this.$page.props.message = 'User was removed from the university';
        } else {
          this.$page.props.error = remove.data.error;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
